<template>
  <div class="page">
    <div class="content_box">
      <div class="search">
        <el-input
          v-model="searchForm.systemName"
          placeholder="请输入你想要输入的内容"
        ></el-input>
        <el-button
          @click="searchAll(searchForm)"
          icon="el-icon-search"
          type="primary"
        ></el-button>
        <el-button
          @click="filtrate()"
          class="show"
          v-if="filtrFlag"
        >收起筛选 <i class="el-icon-arrow-up"></i></el-button>
        <el-button
          @click="filtrate()"
          class="show"
          v-else
        >展开筛选 <i class="el-icon-arrow-down"></i></el-button>
      </div>
      <transition name="fade">
        <div
          v-if="filtrFlag"
          transiton="fade"
          class="fade"
        >
          <div class="fade2">
            <div
              :class="{'clicked':(searchIndex=='')}"
              @click="changeSearch('')"
            >全部</div>
            <div
              :class="{'clicked':(searchIndex==1)}"
              @click="changeSearch(1)"
            >演示系统</div>
            <div
              :class="{'clicked':(searchIndex==2)}"
              @click="changeSearch(2)"
            >设计方案</div>
            <div
              :class="{'clicked':(searchIndex==3)}"
              @click="changeSearch(3)"
            >宣传画册</div>
            <div
              :class="{'clicked':(searchIndex==4)}"
              @click="changeSearch(4)"
            >演示视频</div>
            <div
              :class="{'clicked':(searchIndex==5)}"
              @click="changeSearch(5)"
            >其他</div>
          </div>
          <div>
            <div class="type">类别:</div>
            <div class="type_box">
              <div
                :class="{'clicked':(categoryIndex==0)}"
                @click="categoryClick(0,'')"
              >全部</div>
              <div
                v-for="(item,index) in categoryList"
                :class="{'clicked':(categoryIndex==(index+1))}"
                @click="categoryClick(index+1,item.id)"
                :key="item.id"
              >{{item.categoryName}}</div>
            </div>
          </div>
          <div>
            <div class="type">标签:</div>
            <div
              class="type_box"
              :class="[showAllFlag?'biaoqian':'biaoqian1']"
            >
              <div
                :class="{'clicked':(typeIndex==0)}"
                @click="typeClick(0,'')"
              >全部</div>
              <div
                v-for="(item,index) in flagList"
                :class="{'clicked':(typeIndex==(index+1))}"
                @click="typeClick(index+1,item.id)"
                :key="item.id"
              >{{item.flagName}}</div>
              <div
                class="zhankai"
                @click="showAll()"
                v-if="showAllFlag==true"
              >展开全部<i class="el-icon-arrow-down"></i></div>
              <div
                class="zhankai"
                @click="showAll()"
                v-if="showAllFlag==false"
              >收起全部<i class="el-icon-arrow-up"></i></div>
            </div>
          </div>
        </div>
      </transition>
      <div class="condition">
        <div
          class="actived"
          @click="changeClass(0)"
        >综合排序</div>
        <div
          @click="pulishTime()"
          v-if="publishFlag==1"
        >发布时间<i class="el-icon-caret-bottom"></i></div>
        <div
          @click="pulishTime()"
          v-if="publishFlag==2"
        >发布时间<i class="el-icon-caret-top"></i></div>
        <div
          @click="browseClick()"
          v-if="browseFlag==1"
        >浏览量<i class="el-icon-caret-bottom"></i></div>
        <div
          @click="browseClick()"
          v-if="browseFlag==2"
        >浏览量<i class="el-icon-caret-top"></i></div>
        <div
          @click="downloadClick()"
          v-if="downloadFlag==1"
        >下载量<i class="el-icon-caret-bottom"></i></div>
        <div
          @click="downloadClick()"
          v-if="downloadFlag==2"
        >下载量<i class="el-icon-caret-top"></i></div>
      </div>
      <div
        class="content"
        v-for="item in searchList"
        :key="item.id"
        @click="goInfo(item)"
      >
        <div>
          <div><img :src="item.pictureUrl"> </div>
          <div>
            <div class="one_title">
              <div>
                <div>{{item.systemName}}</div>
                <div>{{item.goodsType|changeType}}</div>
              </div>
              <div
                @click.stop="collection(item.id)"
                v-if="item.collectionFlag==1"
              >
                <div class="shoucang">
                  <img src="../img/shoucang2.png">
                </div>
                <div>收藏</div>
              </div>
              <div
                @click.stop=""
                v-else
              >
                <div class="shoucang">
                  <img src="../img/shoucang1.png">
                </div>
                <div>已收藏</div>
              </div>
            </div>
            <div class="two_title">{{item.systemContent}}</div>
            <div class="three_title">
              <div>￥{{item.goodsPrices}}</div>
              <div class="three_title_two">
                <div>{{item.createTime|changeTime}} 上传 | {{item.previewNum}}阅读 | {{item.downloadNum}}次已下载</div>
              </div>
            </div>
          </div>
        </div>

      </div>
      <el-pagination
        class="page_box"
        @current-change="handleCurrentChange"
        :current-page="currentPage4"
        :page-size="3"
        layout="total, prev, pager, next, jumper"
        :total="totalCount"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import myHeader from "../components/myHeader.vue";
import {
  searchAll,
  getFlagList,
  getCategoryList,
  collection,
  previewAdd,
} from "../js/api.js";
export default {
  components: {
    myHeader,
  },
  data() {
    return {
      input: "",
      filtrFlag: true,
      searchIndex: "",
      typeIndex: 0,
      classIndex: 0,
      categoryIndex: 0,
      currentPage4: 1,
      searchForm: {
        pageNum: 1,
        pageSize: 3,
        systemName: "",
      },
      flagList: [],
      searchList: [],
      categoryList: [],
      totalCount: 0,
      publishFlag: 1,
      browseFlag: 1,
      downloadFlag: 1,
      flagFrom: {},
      showAllFlag: true,
    };
  },
  created() {
    this.searchForm = JSON.parse(this.$route.query.searchForm);
    this.searchIndex = this.searchForm.goodsType;
    this.searchForm.flagId = sessionStorage.getItem("flagId");
    // this.typeIndex  = sessionStorage.getItem("flagId");
    this.getFlagList({});
    this.getCategoryList();
    this.searchAll(this.searchForm);
  },
  methods: {
    //展开
    showAll() {
      this.showAllFlag = !this.showAllFlag;
    },
    //浏览
    async previewAdd(id) {
      let res = await previewAdd(id);
    },
    //收藏
    async collection(id) {
      let res = await collection(id);
      if (res.data.code == 401) {
        window.location.href = res.data.data;
      } else if (res.data.code == 200) {
        this.searchAll(this.searchForm);
        this.$message({
          showClose: true,
          message: res.data.message,
          type: "success",
        });
      }
    },
    //下载次数
    downloadClick() {
      if (this.downloadFlag == 1) {
        this.downloadFlag = 2;
      } else {
        this.downloadFlag = 1;
      }
      this.searchForm.downloadFlag = this.downloadFlag;
      this.searchAll(this.searchForm);
    },
    //发布时间
    pulishTime() {
      if (this.publishFlag == 1) {
        this.publishFlag = 2;
      } else {
        this.publishFlag = 1;
      }
      this.searchForm.publishFlag = this.publishFlag;
      this.searchAll(this.searchForm);
    },
    //浏览量
    browseClick() {
      if (this.browseFlag == 1) {
        this.browseFlag = 2;
      } else {
        this.browseFlag = 1;
      }
      this.searchForm.browseFlag = this.browseFlag;
      this.searchAll(this.searchForm);
    },
    async searchAll(data) {
      let res = await searchAll(data);
      if (res.data.code == 200) {
        this.searchList = res.data.paging.list;
        this.totalCount = Number(res.data.paging.totalCount);
      }
    },
    //标签列表
    async getFlagList(data) {
      let res = await getFlagList(data);
      if (res.data.code == 200) {
        this.flagList = res.data.data;
        if (this.flagList.length > 0) {
          this.flagList.forEach((item, index) => {
            if (item.id == this.searchForm.flagId) {
              this.typeIndex = index + 1;
            }
          });
        }
      }
    },
    //类型列表
    async getCategoryList(data) {
      let res = await getCategoryList(data);
      if (res.data.code == 200) {
        this.categoryList = res.data.data;
      }
    },
    //类别change
    categoryClick(index, e) {
      this.flagFrom.categoryId = e;
      this.categoryIndex = index;
      this.searchForm.categoryId = e;
      this.getFlagList(this.flagFrom);
      this.searchAll(this.searchForm);
    },
    //标签change
    typeClick(index, e) {
      this.typeIndex = index;
      this.searchForm.flagId = e;
      this.searchAll(this.searchForm);
    },
    //跳转详情页面
    goInfo(e) {
      sessionStorage.setItem("router","navPage");
      this.previewAdd(e.id);
      sessionStorage.setItem("infoArr", JSON.stringify(e));
      this.$router.push({
        path: "/infoPage",
        query: {
          id: e.id
        },
      });
    },
    //改变筛选条件
    changeSearch(e) {
      this.flagFrom.systemId = e;
      this.searchIndex = e;
      this.searchForm.goodsType = e;
      this.getFlagList(this.flagFrom);
      this.searchAll(this.searchForm);
    },
    //改变筛选类别
    changeClass(e) {
      this.classIndex = e;
    },
    filtrate() {
      this.filtrFlag = !this.filtrFlag;
    },
    //分页
    handleSizeChange(val) {},
    handleCurrentChange(val) {
      this.searchForm.pageNum = val;
      this.searchAll(this.searchForm);
    },
  },
  filters: {
    changeType(val) {
      if (val == 1) {
        return "演示系统";
      } else if (val == 2) {
        return "设计方案";
      } else if (val == 3) {
        return "宣传画册";
      } else if (val == 4) {
        return "演示视频";
      } else if (val == 5) {
        return "其他";
      } else {
        return "全部";
      }
    },
    changeTime(val) {
      var date = new Date(val); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + "-";
      var M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      var D = date.getDate() < 10 ? "0" + date.getDate() + " " : date.getDate();
      var h =
        date.getHours() < 10
          ? "0" + date.getHours() + ":"
          : date.getHours() + ":";
      var m =
        date.getMinutes() < 10
          ? "0" + date.getMinutes() + ":"
          : date.getMinutes() + ":";
      var s =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return Y + M + D;
    },
  },
};
</script>

<style scoped>
.block {
  height: 80px;
}
.content_box {
  font-size: 16px;
  width: 1200px;
  margin: auto;
}

.search {
  display: flex;
}

.search /deep/ .el-button {
  background: #2160e3;
  border: none;
  color: #fff;
}

.search /deep/ .el-input__inner {
  background: transparent;
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.1s;
}
.fade-enter,
.fade-leave-active {
  opacity: 0;
}

.show {
  background: transparent !important;
  color: #000 !important;
}

.fade {
  margin-top: 20px;
}

.fade > div {
  display: flex;
  background: #fff;
  padding: 0 10px;
}

.fade > div:first-child {
  padding: 15px 10px;
}

.fade2 > div {
  margin-right: 40px;
}

.fade > div > div {
  /* margin-right: 40px; */
  cursor: pointer;
}

.fade > div:first-child {
  margin-bottom: 40px;
}

.fade > div:first-child > div:first-child {
  margin-right: 48px;
}

.type {
  color: #8a99aa;
  width: 40px;
  margin: 15px 40px 15px 0;
}

.type_box {
  display: flex;
  flex-wrap: wrap;
  width: 1100px;
}

.type_box > div {
  margin: 15px 40px 15px 0;
}

.clicked {
  color: #1859e2;
}

.condition {
  margin: 20px 0;
  display: flex;
  padding: 15px 0;
  background: #fff;
}

.condition > div {
  padding: 2px 10px;
  font-size: 15px;
  border: 1px solid #d0d0d0;
  color: #a1a1a1;
  cursor: pointer;
}

.actived {
  background: #1356e2;
  color: #fff !important;
  border: 1px solid #1356e2 !important;
}

.condition > div:nth-child(2),
.condition > div:nth-child(3),
.condition > div:nth-child(4) {
  border-left: 1px solid transparent;
}

.content {
  padding: 60px 0;
  border-bottom: 1px dotted #cacaca;
  cursor: pointer;
  background: #fff;
}

.content > div {
  display: flex;
  margin-bottom: 20px;
  padding: 0 30px;
}

.content > div > div:first-child {
  width: 300px;
  height: 200px;
  margin-right: 30px;
}

.content > div > div:first-child img {
  width: 100%;
  height: 100%;
}

.content > div > div:last-child {
  width: 800px;
  height: 200px;
  padding: 10px 40px;
  box-sizing: border-box;
}

.one_title {
  display: flex;
  justify-content: space-between;
}

.one_title > div {
  display: flex;
  align-items: center;
}

.one_title > div:first-child > div:first-child {
  font-size: 20px;
  font-family: STHeiti;
}

.one_title > div:first-child > div:last-child {
  font-size: 15px;
  margin-left: 15px;
  color: #1e5ee3;
  border: 1px solid #1e5ee3;
  padding: 0px 5px;
  border-radius: 4px;
}

.two_title {
  height: 96px;
  margin-top: 15px;
  color: #666666;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  overflow: hidden;
  line-height: 25px;
}

.three_title {
  display: flex;
  margin-top: 10px;
  justify-content: space-between;
  align-items: center;
}

.three_title > div:first-child {
  color: #fe5c05;
  font-family: STHeiti;
  font-size: 25px;
}

.three_title > div:last-child {
  color: #a3a3a3;
  font-size: 15px;
}

.shoucang img {
  vertical-align: middle;
  margin-right: 10px;
}

.page_box {
  margin-left: 400px;
  margin-top: 40px;
  margin-bottom: 40px;
}

.biaoqian {
  height: 100px;
  overflow: hidden;
  position: relative;
  padding-right: 80px;
}

.biaoqian1 {
  height: auto;
  min-height: 100px;
  overflow: hidden;
  position: relative;
  padding-right: 80px;
}

.zhankai {
  position: absolute;
  top: 0;
  right: -35px;
  color: #1356e2;
  font-size: 13px;
}
</style>